import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=4b5a039a&scoped=true&"
import script from "./order-item.vue?vue&type=script&lang=js&"
export * from "./order-item.vue?vue&type=script&lang=js&"
import style0 from "./order-item.vue?vue&type=style&index=0&id=4b5a039a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a039a",
  null
  
)

export default component.exports